module.exports = __webpack_public_path__ + "img/ico-collapse-cards.f9f022c4.svg";